module.exports = "/*\r\n*********************\r\n**    BOOTSTRAP    **\r\n*********************\r\n*/\n:root {\n  --navbar-toggle-border-color: darken(#a82339, 10%); }\n.periodo {\n  margin-top: 10px;\n  float: right; }\n.table th:not(:first-child) {\n  width: 190px; }\n@media print {\n  .table th,\n  .table td {\n    font-size: 10px; } }\n.table th:not(:first-child) {\n  width: auto;\n  border-left: none; }\n.table tr.border-top {\n  border-top: 2px solid #ddd; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/extratos/relatorio/relatorio-detalhado/relatorio-detalhado.component.scss
// module id = ./src/app/extratos/relatorio/relatorio-detalhado/relatorio-detalhado.component.scss
// module chunks = main